/**
 *
 * Support Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { Navigate } from 'react-router-dom';
import { SupportSubRoutes } from 'modules/Support/supportPagesConfig';
import { lazyLoad } from 'utils/loadable';
import { lazyWebSupportPage } from './lazySupport';

const WebSupportDashPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WebSupportDashPage', webpackPrefetch: true */ './components/WebSupportDashPage'
  ),
);

const WebSupportTicketPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WebSupportTicketPage', webpackPrefetch: true */ './components/WebSupportTicketPage'
  ),
);

export const webSupportMenuRoutes = [
  {
    component: WebSupportDashPage,
    title: 'Support Dashboard',
    path: SupportSubRoutes.DASHBOARD,
  },
  {
    component: WebSupportTicketPage,
    title: 'Support Ticket',
    path: SupportSubRoutes.TICKETS_LIST,
  },
  {
    component: WebSupportTicketPage,
    title: 'Support Ticket',
    path: SupportSubRoutes.TICKET_CONVERSATION,
  },
  {
    component: WebSupportTicketPage,
    title: 'CustomerAssist Ticket',
    path: SupportSubRoutes.CUSTOMER_TICKET_LIST,
  },
  {
    component: WebSupportTicketPage,
    title: 'CustomerAssist Ticket',
    path: SupportSubRoutes.CUSTOMER_TICKET_CONVERSATION,
  },
  {
    component: WebSupportTicketPage,
    title: 'Jobs Ticket',
    path: SupportSubRoutes.JOBS_TICKET_LIST,
  },
  {
    component: WebSupportTicketPage,
    title: 'Jobs Ticket',
    path: SupportSubRoutes.JOBS_TICKET_CONVERSATION,
  },
  {
    component: WebSupportTicketPage,
    title: 'PartnerAssist Ticket',
    path: SupportSubRoutes.PARTNER_TICKET_LIST,
  },
  {
    component: WebSupportTicketPage,
    title: 'PartnerAssist Ticket',
    path: SupportSubRoutes.PARTNER_TICKET_CONVERSATION,
  },
];

// routes declaration
export const webSupportRoutes = [
  {
    component: Navigate,
    path: '/support',

    replace: true,
    to: '/support' + SupportSubRoutes.TICKETS_LIST, // '/support/dashboard' //TODO
    needsAuth: true,
  },
  {
    component: lazyWebSupportPage,
    path: '/support/*',
    title: 'Support',
    needsAuth: true,
  },
];
